module.exports = __webpack_public_path__ + "img/zhaoyiqian.73020bbc.jpg";